import { gql } from '@apollo/client'

const GET_CAMPAIGN_BY_ID = gql`
  query ($campaignId: ID!) {
    getCampaign(campaignId: $campaignId) {
      campaignId
      name
      segmentation {
        campaignType
        audienceType
      }
      type
      point
      multiplier
      startDate
      endDate
      points {
        startDate
        endDate
        description
        countOfDays
      }
      status
      responsible
      changeHistory {
        responsible
        changes {
          field
          values {
            old
            new
          }
        }
        justification
        updatedAt
      }
      createdAt
      brand {
        BOT
        QDB
        BLZ
        EUD
      }
      contentByBrand {
        BOT {
          buttonUrl
        }
        QDB {
          buttonUrl
        }
        BLZ {
          buttonUrl
        }
        EUD {
          buttonUrl
        }
      }
      content {
        title
        description
        imageUrl
        buttonText
        buttonUrl
        showModal
        details {
          pageTitle
          pageDescription
          steps
          rules
        }
      }
    }
  }
`

export default GET_CAMPAIGN_BY_ID
